















import Vue from 'vue'
import { KeyScaleChord, KeyScaleDegree, ScaleInKey } from '../application/models/ScaleInKey'
import { ChordProgressionChord } from '../application/models/chordProgression'

export default Vue.extend({
  props: {
    chord: { type: ChordProgressionChord },
    scaleInKey: { type: ScaleInKey },
    isFlats: { type: Boolean }
  },
  computed: {
    keyScaleDegree(): KeyScaleDegree {
      return this.chord.getDegree(this.scaleInKey, this.isFlats)
    },
    keyScaleChord(): KeyScaleChord {
      return this.chord.getChord(this.scaleInKey, this.isFlats)
    },
    title(): string {
      const degree = this.keyScaleChord.degree
      const chord = this.keyScaleChord.chordName
      return `${degree} : ${chord}`
    },
    cssClass(): string {
      return this.keyScaleDegree.chordFunction.cssClass
    },
    className(): string {
      return `has-background-${this.cssClass}`
    }
  }
})
